import React from "react";
import Menu1Header from "../menu-1-header/index";
import "./style.css";

function Header() {
  return (
    <div className="div-header">
      <Menu1Header />
    </div>
  );
}

export default Header;
